import { render } from "./block-script.vue?vue&type=template&id=24bc9682&scoped=true"
import script from "./block-script.vue?vue&type=script&lang=js"
export * from "./block-script.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./block-script.vue?vue&type=style&index=1&id=24bc9682&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bc9682"]])

export default __exports__